import uuid from 'uuid'

export const mutations = {
  ['REFRESH_PATIENT_CASES'](state, refreshCases) {
    state.refreshPatientCases = refreshCases
  },
  ['REFRESH_PATIENT_TRIALS'](state, refreshTrials) {
    state.refreshPatientTrials = refreshTrials
  }
}

export const actions = {
  async ['REFRESH_PATIENT_CASES']({ commit }) {
    commit('REFRESH_PATIENT_CASES', uuid())
  },
  async ['REFRESH_PATIENT_TRIALS']({ commit }) {
    commit('REFRESH_PATIENT_TRIALS', uuid())
  }
}

export const getters = {}
